import 'katex/dist/katex.min.css'
import Latex from 'react-latex-next'

const Explanation = ({ explanation }) => {
  return (
    <div
      id="explain-container"
      className="explanation overflow-auto !h-[140px] text-over-ternary-background flex grow relative pt-1 md:pt-2 md:pb-2 lg:pl-0 lg:pr-0 md:pl-[10px] md:pr-[10px] max-w-[95vw]"
    >
      <Latex>{explanation}</Latex>
    </div>
  )
}

export default Explanation
